module.exports = __webpack_public_path__ + "img/badminton.f5577b2f.jpg";